import { breakpoints } from '../../styles/theme';
import OrderPanelTemplate from './OrderPanelTemplate';
import styled from 'styled-components';
import { rem } from 'polished';

export const OrderPanelStyled = styled(OrderPanelTemplate)`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999999;
    min-height: ${rem(32)};
    padding: ${rem(14)} 0;
    background: ${({ theme }) => theme.colors.grey9};
    width: 100%;

    .configLeftSectionContainer {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    @media (min-width: ${breakpoints.md}px) {
        position: sticky;
        top: ${({ isUserLoggedInAsDealer }) => (isUserLoggedInAsDealer ? rem(36) : 0)};
    }

    .wrapper {
        width: auto;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
        }

        @media only screen and (min-width: 48em) {
            max-width: 46rem !important;
            margin: 0 auto;
        }

        @media only screen and (min-width: 64em) {
            max-width: 61rem !important;
            margin: 0 auto;
        }

        @media only screen and (min-width: 75em) {
            max-width: ${({ isWide }) => (isWide ? '100%' : '94rem')} !important;
            margin: 0 auto;
        }
    }

    .sectionWrapper {
        display: flex;
        width: 60%;
    }

    .priceSection {
        padding-left: ${rem(15)};

        .catalogPrice {
            font-size: ${rem(8)};
            padding-bottom: ${rem(8)};
        }

        .price {
            display: flex;
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            .cashPrice {
                white-space: nowrap;
            }

            .showPriceExcludedVAT {
                margin-right: ${rem('10px')};
            }

            .priceConjunction {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                padding: 0 ${rem(10)};
                margin-top: ${rem(2)};
            }

            .vertical {
                margin: 0;
                padding-left: ${rem(5)};

                svg {
                    g {
                        circle,
                        line {
                            stroke: ${({ theme }) => theme.colors.primary};
                        }
                    }
                }
            }
        }

        .deposit {
            p {
                margin: 0;
                font-size: ${rem(8)};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }
    }
    .benefitSection {
        padding: 0 ${rem(15)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin-top: ${rem(20)};

        .bullet-points {
            transform: scaleY(0);
            transform-origin: top;
            transition: transform 0.2s ease;
            height: 0;
            margin: 0;
            padding: 0 ${rem(5)};
        }

        .showBenefits {
            transform: scaleY(1);
            height: auto;
            margin: ${rem(12)} ${rem(12)} ${rem(12)} 0;
        }

        .allow-bullet-points {
            padding-left: ${rem(16)};
        }

        &.desktop {
            display: none;

            @media (min-width: ${breakpoints.md}px) {
                display: block;
                border-left: 2px solid ${({ theme }) => theme.colors.grey16};
                max-width: 50%;
                width: 100%;
            }
        }

        &.mobile {
            display: block;

            @media (min-width: ${breakpoints.md}px) {
                display: none;
            }
        }

        @media (min-width: ${breakpoints.md}px) {
            margin-top: 0;
        }

        .heading {
            text-transform: capitalize;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: flex;
            align-items: center;
            cursor: pointer;

            &.isOpen {
                svg {
                    transform: rotate(-180deg);
                }
            }

            svg {
                margin-left: ${rem(10)};

                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .bullet-points.disable-bullet-points {
            padding-left: 0;
            margin-top: 0;

            li {
                list-style: none;
            }
        }
    }
    .buttonSection {
        padding-left: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        border-left: 2px solid ${({ theme }) => theme.colors.grey16};
        @media (max-width: ${breakpoints.md}px) {
            display: none;
        }

        .links {
            button {
                background: none;
                border: none;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                color: ${({ theme }) => theme.colors.primary};
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 0;

                &:hover {
                    border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
                }

                .icon-wrapper {
                    height: ${rem(12)};

                    svg {
                        margin-left: ${rem(5)};

                        path {
                            fill: ${({ theme }) => theme.colors.primary};
                        }
                    }
                }
            }
        }
    }

    .desktopContactSection {
        display: flex;
        justify-content: center;
        flex-direction: column;

        .phoneLink {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            cursor: pointer;
            text-decoration: unset;
            padding-top: ${rem(10)};

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.blue2};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.white};
        height: ${rem(40)};
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: -${rem(15)};
        padding: 0 ${rem(20)};
        cursor: pointer;

        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }

        span {
            display: flex;
            align-items: center;

            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.white} !important;
                    }
                }
            }
        }

        .label {
            svg {
                margin-left: ${rem(5)};
            }
        }

        .phone {
            svg {
                margin-right: ${rem(5)};
            }
        }
    }
`;
